import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'imgCountryFlag',
  standalone: true
})
export class CountryFlagPipe implements PipeTransform {

  transform(countryCode: string, ...args: unknown[]): unknown {
    return `assets/country-flags/${countryCode}.svg`;
  }

}
